import { Media } from '../payload-types';

export function makeMediaUrl(media: Media, src: string): URL {
  const url = new URL(src);

  url.searchParams.set('v', new Date(media.updatedAt).valueOf().toString());

  return url;
}
